import React from 'react';
import ApexCharts from 'react-apexcharts';
import noData from "../../../assets/images/noData.png"
// Function to group the data by month and extract total_trades for each month
const groupDataByMonth = (data) => {
  // Assuming data has a 'months' property
  if (!data || !data.months) {
    console.error("Data is missing 'months' key.");
    return [];
  }
  
  return Object.entries(data.months).map(([month, values]) => ({
    month,
    total_trades: values.total_trades,
    total_price: values.total_price,
  }));
};

const AdminMonthChart = ({ data }) => {
  // Group data by month
  const groupedData = groupDataByMonth(data);

  if (groupedData.length === 0) {
    return  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={noData} height="255px"/></div>
  }

  // Prepare data for the chart
  const categories = groupedData.map(item => item.month); // X-axis (months)
  const totalTrades = groupedData.map(item => item.total_trades); // Y-axis (total trades)

  // Chart configuration options
  const chartOptions = {
    chart: {
      type: 'bar',
      height: 350,
    },
    xaxis: {
      categories: categories, // X-axis labels (Months)
      title: {
        text: 'Month',
        style: {
          fontSize: '14px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: "600",
          color: "#000000de",
        },
      },
    },
    yaxis: {
      title: {
        text: 'Total Trades',
        style: {
          fontSize: '14px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: "600",
          color: "#000000de",
        },
      },
    },
    colors: ['#f4a99b', '#a5faa5'], // Alternating colors

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%', // Width of each bar
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels inside bars
    },
    tooltip: {
      y: {
        formatter: function (value, { dataPointIndex }) {
          const totalPrice = groupedData[dataPointIndex]?.total_price || 0;
          return `Total Trades: ${value}<br/>Total Price: ₹${totalPrice.toLocaleString()}`; // Tooltip content
        },
      },
    },
    legend: {
      show: false,
    },
  };

  // Data series for the chart
  const chartSeries = [
    {
      name: '',
      data: totalTrades, // Y-axis (Total Trades)
    },
  ];

  return (
    <div>
      <ApexCharts
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={240}
      />
    </div>
  );
};

export default AdminMonthChart;
